import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { connect } from 'utils/react-redux';

import containerQuery from 'decorators/containerQuery';

import Link from 'components/Link';
import Icon from 'components/Icon';
import {setStep} from "../../redux/signup";

import styles from './RegistrationLayout.module.css';
import Button from "../../../../components/Button";

const cx = classNames.bind(styles);

class PublicRegistrationLayout extends PureComponent {
  static propTypes = {
    step: PropTypes.string.isRequired,
    children: PropTypes.node,
    containerQuery: PropTypes.object,
    isLite: PropTypes.bool,
    setStep: PropTypes.func.isRequired
  };

  static defaultProps = {
    step: undefined,
    children: undefined,
    containerQuery: {},
    isLite: false,
    setStep: () => { },
  };

  render() {
    const { isLite } = this.props;

    const width = window.outerWidth || window.innerWidth;

    return (
      <div className={cx('layout', this.props.containerQuery)}>
        <div className={cx('content')}>
          {isLite ||
            <div className={cx('sidebar')}>
              {width > 600 ?
                <>
                  <div className={cx('link')}>
                    <Link
                      to='/login'
                      color='blue'
                      hover='sapphirine'
                      large
                      bold
                    >
                      <div className={cx('icon')}>
                        <Icon icon='arrow-login' width={28} height={28} />
                      </div>
                      Вход
                    </Link>
                  </div>
                  <div className={cx('note')}>
                    Войдите, если вы
                    зарегистрированы
                    в системе
                  </div>
                </>
                :
                  <div className={cx('link')}>
                    {width <= 600 && this.props.step === 'institute' ?
                      <Button
                        onClick={()=> {this.props.setStep('user')}}
                        customClass={'button_recover'}
                      >
                        <Icon icon='arrow-left-mobile' width={16} height={16} />
                      </Button>
                      :
                      <Link
                        to='/login'
                        color='black'
                        large
                        bold
                      >
                        <div className={cx('icon')}>
                          <Icon icon='arrow-left-mobile' width={16} height={16} />
                        </div>
                      </Link>
                    }
                  </div>
                }
            </div>
          }
          <div className={cx('page')}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  step: state.Public.signup.step,
});

const mapDispatchToProps = {
  setStep,
};

export default R.compose(
  containerQuery(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PublicRegistrationLayout);
